import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Form } from 'react-bootstrap';

const remarkPlugins = [remarkGfm];

const components = {
    p: ({ ...props }: any) => <span {...props} />,
    a: ({ ...props }: any) => (
        <a target="_blank" rel="noreferrer noopener" {...props} />
    ),
};

interface ConfigFieldDescriptionProps {
    description?: string;
}

const ConfigFieldDescription = ({ description }: ConfigFieldDescriptionProps) => {
    if (!description) return null;
    return (
        <Form.Text className="text-muted">
            <Markdown remarkPlugins={remarkPlugins} components={components}>
                {description}
            </Markdown>
        </Form.Text>
    );
};

export default ConfigFieldDescription;
